module.exports = __webpack_public_path__ + "img/icon_map_36_off_101.9d475415.png";